import { action, thunk } from "easy-peasy";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../config/firebase.config";
import { signOut } from "firebase/auth";

const authModel = {
  // state
  user: null,
  loading: true,
  error: null,

  // actions
  setUser: action((state, payload) => {
    state.user = payload;
  }),

  setLoading: action((state, payload) => {
    state.loading = payload;
  }),

  setError: action((state, payload) => {
    state.error = payload;
  }),

  //  thunks
  initAuthListener: thunk((actions) => {
    actions.setLoading(true);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        actions.setUser(user);
      } else {
        actions.setUser(null);
      }
      actions.setLoading(false);
    });
  }),

  handleLogout: thunk(async (actions) => {
    actions.setLoading(true);
    actions.setError(null);
    try {
      await signOut(auth);
      actions.setUser(null);
    } catch (err) {
      actions.setError(err.message);
    } finally {
      actions.setLoading(false);
    }
  }),
};

export default authModel;
